(function () {
  'use strict';

  var config = window.allPostsConfig || {};
  var perPage = config.perPage || 9;
  var showCategory = config.showCategory !== false;
  var showExcerpt = config.showExcerpt !== false;

  var listEl = document.getElementById('all-posts-list');
  var paginationEl = document.getElementById('all-posts-pagination');
  var dataEl = document.getElementById('all-posts-data');
  var filterEl = document.getElementById('all-posts-filter');
  var currentPage = 1;
  var allArticles = [];

  var filterGroups = [
    {
      key: 'product_type',
      label: 'Product Type',
      options: ['Kitchen Sinks','Bathroom Sinks','Faucets','Vanities','Toilets','Bathtubs','Shower Systems','Bathroom Accessories','ADA Products','Materials & Finishes']
    },
    {
      key: 'audience',
      label: 'Audience',
      options: ['Architects & Designers','Builders & Contractors','Developers','Fabricators','Engineers','Purchasing Teams','Property Managers']
    },
    {
      key: 'project_type',
      label: 'Project Type',
      options: ['Multifamily','Commercial','Hospitality','Student Housing','Senior Living','New Construction','Renovation','High-Traffic Spaces']
    }
  ];

  var activeFilters = { product_type: [], audience: [], project_type: [] };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildImageUrl(src, width) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + width + 'x$1$2');
  }

  function readTime(article) {
    var override = parseInt(article.read_time_override, 10);
    if (!isNaN(override) && override > 0) return override;
    var words = article.word_count || 0;
    if (!words && article.excerpt) words = article.excerpt.trim().split(/\s+/).length;
    return Math.floor(words / 180) + 1;
  }

  function renderBadges(val) {
    if (!val || (Array.isArray(val) && val.length === 0)) return '';
    var items = Array.isArray(val) ? val : [val];
    return items.map(function (v) {
      return '<span class="article-item__audience-badge">' + escapeHtml(v) + '</span>';
    }).join('');
  }

  function renderCard(article) {
    var isB2B = !!article.cluster;
    var mins = readTime(article);
    var metaHtml = '<div class="article-item__meta">' +
      '<span class="article-item__read-time">' + mins + ' min read</span>' +
      renderBadges(article.audience) +
      '</div>';
    var excerptHtml = '';
    if (showExcerpt && article.excerpt) {
      excerptHtml = '<div class="article-item__excerpt text--small">' + escapeHtml(article.excerpt) + '</div>';
    }

    if (isB2B) {
      var clusterHtml = '<span class="article-item__cluster">' + escapeHtml(article.cluster) + '</span>';
      var subtitleHtml = article.subtitle
        ? '<p class="article-item__subtitle">' + escapeHtml(article.subtitle) + '</p>'
        : (excerptHtml || '');
      var b2bMetaHtml = '<div class="article-item__meta">' +
        '<span class="article-item__read-time">' + mins + ' min read</span>' +
        '</div>';
      var b2bImageHtml = '';
      if (article.image) {
        b2bImageHtml = '<a href="' + article.url + '" class="article-item__image-container">' +
          '<img src="' + buildImageUrl(article.image, 800) + '" alt="' + escapeHtml(article.title) + '" loading="lazy" class="article-item__image">' +
          '<span class="article-item__arrow prev-next-button prev-next-button--small prev-next-button--next"><svg focusable="false" width="15" height="12" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg></span>' +
          '</a>';
      }
      return '<div class="article-item article-item--b2b image-zoom">' +
        b2bImageHtml +
        '<div class="article-item__content">' +
          clusterHtml +
          '<h3 class="article-item__title heading h4"><a href="' + article.url + '">' + escapeHtml(article.title) + '</a></h3>' +
          subtitleHtml +
          b2bMetaHtml +
        '</div>' +
      '</div>';
    }

    // Legacy card
    var imageHtml = '';
    if (article.image) {
      imageHtml = '<a href="' + article.url + '" class="article-item__image-container">' +
        '<img src="' + buildImageUrl(article.image, 800) + '" alt="' + escapeHtml(article.title) + '" loading="lazy" class="article-item__image">' +
        '<span class="article-item__arrow prev-next-button prev-next-button--small prev-next-button--next"><svg focusable="false" width="15" height="12" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg></span>' +
        '</a>';
    }
    return '<div class="article-item image-zoom">' +
      imageHtml +
      '<div class="article-item__content text-container">' +
        '<h3 class="article-item__title heading h4"><a href="' + article.url + '">' + escapeHtml(article.title) + '</a></h3>' +
        excerptHtml +
      '</div>' +
    '</div>';
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    if (page === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', page);
    }
    return url.toString();
  }

  function hasActiveFilters() {
    return filterGroups.some(function (g) { return activeFilters[g.key].length > 0; });
  }

  function filteredArticles() {
    if (!hasActiveFilters()) return allArticles;
    return allArticles.filter(function (a) {
      return filterGroups.some(function (g) {
        if (activeFilters[g.key].length === 0) return false;
        var val = a[g.key] || '';
        return activeFilters[g.key].some(function (sel) {
          return val === sel || (Array.isArray(val) && val.indexOf(sel) !== -1);
        });
      });
    });
  }

  function renderFilterBar() {
    if (!filterEl) return;

    var html = '<span class="all-posts-filter__label">Filter articles by:</span><ul class="all-posts-filter__groups" role="list">';
    filterGroups.forEach(function (g) {
      var hasActive = activeFilters[g.key].length > 0;
      var labelSuffix = hasActive ? ' (' + activeFilters[g.key].length + ')' : '';
      html += '<li class="all-posts-filter__group" data-group="' + g.key + '">' +
        '<button class="all-posts-filter__group-btn' + (hasActive ? ' all-posts-filter__group-btn--active' : '') + '" aria-expanded="false">' +
          escapeHtml(g.label) + labelSuffix +
          '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="all-posts-filter__dropdown" role="listbox" aria-multiselectable="true">';
      g.options.forEach(function (opt) {
        var checked = activeFilters[g.key].indexOf(opt) !== -1;
        html += '<label class="all-posts-filter__option">' +
          '<input type="checkbox" data-group="' + g.key + '" data-value="' + escapeHtml(opt) + '"' + (checked ? ' checked' : '') + '>' +
          escapeHtml(opt) +
          '</label>';
      });
      html += '</div></li>';
    });
    html += '</ul>';

    var anyActive = hasActiveFilters();
    html += '<button class="all-posts-filter__clear' + (anyActive ? '' : ' all-posts-filter__clear--hidden') + '">Clear filters</button>';

    filterEl.innerHTML = html;

    filterEl.querySelectorAll('.all-posts-filter__group-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = this.closest('.all-posts-filter__group');
        var isOpen = group.classList.contains('all-posts-filter__group--open');
        filterEl.querySelectorAll('.all-posts-filter__group--open').forEach(function (g) {
          g.classList.remove('all-posts-filter__group--open');
          g.querySelector('.all-posts-filter__group-btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          group.classList.add('all-posts-filter__group--open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    filterEl.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var group = this.getAttribute('data-group');
        var val = this.getAttribute('data-value');
        if (this.checked) {
          if (activeFilters[group].indexOf(val) === -1) activeFilters[group].push(val);
        } else {
          activeFilters[group] = activeFilters[group].filter(function (v) { return v !== val; });
        }
        currentPage = 1;
        renderFilterBar();
        renderPage(1, false);
      });
    });

    filterEl.querySelector('.all-posts-filter__clear').addEventListener('click', function () {
      filterGroups.forEach(function (g) { activeFilters[g.key] = []; });
      currentPage = 1;
      renderFilterBar();
      renderPage(1, false);
    });

  }

  document.addEventListener('click', function (e) {
    if (filterEl && !filterEl.contains(e.target)) {
      filterEl.querySelectorAll('.all-posts-filter__group--open').forEach(function (g) {
        g.classList.remove('all-posts-filter__group--open');
        g.querySelector('.all-posts-filter__group-btn').setAttribute('aria-expanded', 'false');
      });
    }
  });

  function renderPage(page, scroll) {
    currentPage = page;
    var articles = filteredArticles();
    var start = (page - 1) * perPage;
    var pageArticles = articles.slice(start, start + perPage);

    listEl.innerHTML = pageArticles.length
      ? pageArticles.map(renderCard).join('')
      : '<p class="all-posts-filter__empty">No articles found in this category yet.</p>';
    renderPagination(articles.length);

    window.history.pushState({}, '', pageUrl(page));
    if (scroll) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function renderPagination(totalCount) {
    var totalPages = Math.ceil((totalCount !== undefined ? totalCount : allArticles.length) / perPage);
    if (totalPages <= 1) {
      paginationEl.style.display = 'none';
      return;
    }

    var parts = [];
    for (var i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
        parts.push({ title: i, is_link: i !== currentPage });
      } else if (parts.length && parts[parts.length - 1].title !== '...') {
        parts.push({ title: '...', is_link: false });
      }
    }

    var html = '<page-pagination class="pagination"><nav class="pagination__nav">';

    if (currentPage > 1) {
      html += '<a href="' + pageUrl(currentPage - 1) + '" class="pagination__nav-item" aria-label="Previous page">' +
        '<svg aria-hidden="true" focusable="false" width="16" height="13" viewBox="0 0 16 13"><path d="M14.5 6.5H1M6.5 1L1 6.5l5.5 5.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>';
    }

    parts.forEach(function (part) {
      if (part.is_link) {
        html += '<a href="' + pageUrl(part.title) + '" class="pagination__nav-item heading heading--small">' + part.title + '</a>';
      } else {
        html += '<span class="pagination__nav-item heading heading--small"' + (part.title === currentPage ? ' aria-current="page"' : '') + '>' + part.title + '</span>';
      }
    });

    if (currentPage < totalPages) {
      html += '<a href="' + pageUrl(currentPage + 1) + '" class="pagination__nav-item" aria-label="Next page">' +
        '<svg aria-hidden="true" focusable="false" width="16" height="13" viewBox="0 0 16 13"><path d="M1.5 6.5H15M9.5 1L15 6.5 9.5 12" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>';
    }

    html += '</nav></page-pagination>';
    paginationEl.innerHTML = html;
    paginationEl.style.display = '';

    paginationEl.querySelectorAll('a.pagination__nav-item').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(this.href);
        var page = parseInt(url.searchParams.get('page'), 10) || 1;
        renderPage(page, true);
      });
    });
  }

  function init() {
    if (!listEl || !dataEl) return;

    try {
      allArticles = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    allArticles.sort(function (a, b) {
      return b.published_at - a.published_at;
    });

    renderFilterBar();
    var initialPage = parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1;
    renderPage(initialPage, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
